<template>
  <div class="content">
    <div class="row text-left">
      <div class="col-md-12">
        <p class="text-black-50">
          Новый базовый ТСР
          <i v-on:click="addNewOne" class="tim-icons icon-puzzle-10"></i>
        </p>
      </div>
    </div>
    <big-one :content="content" :type = "type" :a-page="true" :tuning="true" :new-one="newOne"></big-one>
  </div>
</template>
<script>

const baseTSRName = {header: "Наименование", name: "name", show: true, sort: true, direction: true, contains: ""};
const baseTSRLifeTime = {header: "Нормативный период", name: "lifeTime", show: true, periodView: true};

export default{
  data() {
    return {
      type: "base_tsr",
      content: [baseTSRName, baseTSRLifeTime],
      newOne: null
    }
  },
  methods: {
    addNewOne() {
      let object = {name: '', id: 0, lifetime: 0};
      this.newOne = ({object: object, id: object.id, view: 'edit'});
    }
  }
}
</script>
<style>
</style>
